// Configuration for all record-based sections.
// Each section defines its title, icon key, fields (form + table), and grade options.

export const GRADES = ["KG2", "KG3", ...Array.from({ length: 12 }, (_, index) => `G${index + 1}`)];

export const gradesForSchool = (schoolKey, gender = "") => {
  if (schoolKey === "durat" && gender === "male") return GRADES.slice(GRADES.indexOf("G4"));
  return schoolKey === "abaq" ? GRADES.slice(0, 11) : GRADES;
};

export const normalizeGrade = (grade) => String(grade || "").trim().toUpperCase().replace(/\s+/g, "").replace(/^GRADE(\d+)$/, "G$1");

export const PLAN_CONFIG = {
  key: "plan_task",
  title: "الخطة الأسبوعية",
  icon: "Calendar",
  fields: [
    { name: "week", label: "الأسبوع", type: "text", required: true },
    { name: "date", label: "الفترة", type: "text" },
    { name: "program", label: "البرنامج", type: "text", required: true },
    { name: "target", label: "الفئة المستهدفة", type: "text" },
    { name: "works", label: "أبرز الأعمال", type: "textarea" },
    { name: "status", label: "التنفيذ", type: "select", options: ["نفذ", "لم ينفذ"] },
    { name: "notes", label: "ملاحظات", type: "textarea" },
  ],
  columns: ["week", "date", "program", "target", "works", "status", "notes"],
};

export const DEFAULT_PLAN_WEEKS = [
  ["الأول", "التهيئة الإرشادية", "جميع الطلاب", "استقبال الطلاب – التهيئة النفسية"],
  ["الثاني", "تعزيز السلوك الإيجابي", "جميع الطلاب", "تطبيق جائزة التميز السلوكي"],
  ["الثالث", "رعاية الحالات الخاصة", "الحالات الخاصة", "متابعة الحالات الخاصة"],
  ["الرابع", "برنامج رفق", "جميع الطلاب", "خفض العنف والتنمر"],
  ["الخامس", "رفع دافعية التعلم", "المتعثرون", "الخطط العلاجية"],
  ["السادس", "المهارات النفسية", "جميع الطلاب", "تنمية المهارات"],
  ["السابع", "التوجيه المهني", "العليا", "التعريف بالمسارات"],
  ["الثامن", "المهارات النفسية", "جميع الطلاب", "الوقاية النفسية"],
  ["التاسع", "رعاية الحالات", "الحالات الخاصة", "متابعة الغياب"],
  ["العاشر", "رفع الدافعية", "المتعثرون", "متابعة النتائج"],
  ["الحادي عشر", "التعزيز الإيجابي", "جميع الطلاب", "تكريم المتميزين"],
  ["الثاني عشر", "الانضباط المدرسي", "جميع الطلاب", "خفض الغياب"],
  ["الثالث عشر", "رفع الدافعية", "المتعثرون", "متابعة الدافعية"],
  ["الرابع عشر", "الأمن الرقمي", "جميع الطلاب", "الاستخدام الآمن"],
  ["الخامس عشر", "التوجيه المهني", "العليا", "التخصصات والكليات"],
  ["السادس عشر", "رفع التحصيل", "المتعثرون", "تنظيم الوقت"],
  ["السابع عشر", "تهيئة الاختبارات", "جميع الطلاب", "خفض القلق"],
  ["الثامن عشر", "متابعة الاختبارات", "جميع الطلاب", "الدعم النفسي"],
  ["التاسع عشر", "الاختبارات النهائية", "جميع الطلاب", "المتابعة اليومية"],
  ["العشرون", "التقارير الختامية", "الإدارة", "إعداد التقارير"],
];

export const SEMESTER_PLAN_DATA = {
  first: [
    ["الأول", "30/08-03/09/2026م", "التهيئة الإرشادية والأسبوع التمهيدي", "جميع الطلاب وأسرهم", "تهيئة الطلبة نفسياً وتربوياً واجتماعياً، وتعريفهم بأنظمة المدرسة، وتفعيل التواصل بين الأسرة والمدرسة."],
    ["الثاني", "06-10/09/2026م", "تعزيز السلوك الإيجابي", "جميع الطلاب", "الإعلان عن القيم المستهدفة، والتركيز على الانضباط، وتفعيل جائزة التميز السلوكي."],
    ["الثالث", "13-17/09/2026م", "تعزيز السلوك الإيجابي ورعاية الحالات الخاصة", "جميع الطلاب والحالات الخاصة", "تعزيز قيم التسامح والإيجابية، حصر الحالات الخاصة وتحليل احتياجاتها، وتقديم التدخلات المناسبة."],
    ["الرابع", "20-22/09/2026م", "برنامج رفق لخفض العنف", "الطلاب ومنسوبو المدرسة وأولياء الأمور", "تنفيذ الأسبوع المكثف لبرنامج رفق، والتوعية بالوقاية من العنف وأساليب التعامل التربوي."],
    ["الخامس", "27/09-01/10/2026م", "تنمية الدافعية لرفع التحصيل الدراسي", "جميع الطلاب، مع دعم المتعثرين", "تحليل نتائج الطلاب، وتقديم خطط رفع الدافعية والتحصيل، وتعزيز دور الأسرة."],
    ["السادس", "04-08/10/2026م", "تعزيز المهارات النفسية والاجتماعية (نبيه ودرع)", "طلاب التعليم العام", "تحديد المهارات المستهدفة وإعداد خطة زمنية لتنمية المهارات الانفعالية والاجتماعية."],
    ["السابع", "11-15/10/2026م", "التوجيه المهني", "طلاب التعليم العام", "تعريف الطلاب بميولهم وقدراتهم والمسارات التعليمية والمهنية المناسبة."],
    ["الثامن", "18-22/10/2026م", "استمرار تعزيز المهارات النفسية", "طلاب التعليم العام", "تنفيذ أنشطة الوقاية النفسية وتنمية المهارات، واستثمار المجالس والأنشطة المدرسية."],
    ["التاسع", "25-29/10/2026م", "رعاية ودعم الحالات الخاصة", "الحالات الخاصة", "حصر الحالات وتقديم الخدمات التربوية والنفسية ومتابعة خطط الرعاية."],
    ["العاشر", "01-05/11/2026م", "متابعة تنمية الدافعية والتحصيل", "طلاب التعليم العام", "متابعة التدخلات والخطط العلاجية وقياس أثرها في رفع التحصيل."],
    ["الحادي عشر", "08-12/11/2026م", "استمرار رعاية الحالات الخاصة", "الحالات الخاصة وأسرهم", "متابعة الخدمات المقدمة للحالات الخاصة والتنسيق مع الأسرة ومنسوبي المدرسة."],
    ["الثاني عشر", "15-19/11/2026م", "الانضباط المدرسي", "جميع الطلاب وأولياء الأمور", "تعزيز الانضباط والتوعية بآثار الغياب والتأخر وقواعد السلوك والمواظبة."],
    ["الثالث عشر", "29/11-03/12/2026م", "تنمية الدافعية لرفع التحصيل الدراسي", "جميع الطلاب", "متابعة مستوى التحصيل وتقديم التدخلات التربوية المناسبة وتعزيز قيمة الانضباط."],
    ["الرابع عشر", "06-10/12/2026م", "الاستخدام الآمن للإنترنت والألعاب الإلكترونية", "الطلاب وأولياء الأمور", "التوعية بالاستخدام الآمن للتقنية ومخاطر التواصل الاجتماعي والألعاب الإلكترونية."],
    ["الخامس عشر", "13-17/12/2026م", "استمرار التوجيه المهني", "طلاب التعليم العام", "متابعة التوجيه للمسارات والتخصصات والفرص الدراسية والمهنية."],
    ["السادس عشر", "20-24/12/2026م", "متابعة تنمية الدافعية والتحصيل", "الطلاب المتوقع تعثرهم", "إعداد الخطط العلاجية ومتابعة إتقان المهارات الأساسية ورفع التحصيل."],
    ["السابع عشر", "27-31/12/2026م", "التهيئة الإرشادية للاختبارات", "جميع الطلاب", "تعريف الطلاب بتعليمات الاختبارات، وخفض القلق، وتعزيز الاستعداد النفسي."],
    ["الثامن عشر", "03-07/01/2027م", "استكمال التهيئة للاختبارات والتقارير الختامية", "جميع الطلاب والإدارة المدرسية", "متابعة الاختبارات، واستكمال توثيق البرامج ورفع التقرير الختامي للفصل."],
  ],
  second: [
    ["الأول", "17-21/01/2027م", "تنمية الدافعية لرفع التحصيل الدراسي", "جميع الطلاب", "متابعة تحليل النتائج، وتقديم التدخلات التربوية، وإشراك الأسرة في تنمية الدافعية."],
    ["الثاني", "24-28/01/2027م", "تعزيز السلوك الإيجابي", "جميع الطلاب", "الإعلان عن القيم المستهدفة والتركيز على الانضباط وتفعيل جائزة التميز السلوكي."],
    ["الثالث", "31/01-04/02/2027م", "تعزيز السلوك الإيجابي ورعاية الحالات الخاصة", "جميع الطلاب والحالات الخاصة", "تعزيز قيم التسامح والإيجابية، وتحليل احتياجات الحالات وتقديم التدخلات."],
    ["الرابع", "07-11/02/2027م", "تعزيز المهارات النفسية والاجتماعية (نبيه ودرع)", "طلاب التعليم العام", "تنفيذ خطة تنمية المهارات الانفعالية والاجتماعية وتعزيز السلوك الإيجابي."],
    ["الخامس", "14-18/02/2027م", "الأسبوع المكثف لبرنامج رفق", "الطلاب ومنسوبو المدرسة وأولياء الأمور", "تنفيذ أنشطة الوقاية من العنف ورصد الحالات وتقديم الخدمات الوقائية والعلاجية."],
    ["السادس", "23-25/02/2027م", "تنمية الدافعية والتهيئة لاختبارات منتصف الفصل", "جميع الطلاب", "رفع الدافعية والتحصيل والتهيئة لاختبارات أعمال السنة، مع متابعة خطط المدرسة."],
    ["السابع", "14-18/03/2027م", "التوجيه المهني", "طلاب التعليم العام", "تعريف الطلاب بالميول والقدرات والمسارات والمعاهد والكليات والفرص المهنية."],
    ["الثامن", "21-25/03/2027م", "استمرار تعزيز المهارات النفسية", "طلاب التعليم العام", "تنفيذ أنشطة الوقاية النفسية وتنمية المهارات ومراعاة المناسبات التوعوية."],
    ["التاسع", "28/03-01/04/2027م", "رعاية ودعم الحالات الخاصة", "الحالات الخاصة", "تحقيق التوافق النفسي والاجتماعي والتربوي ومتابعة خطط الرعاية."],
    ["العاشر", "04-08/04/2027م", "متابعة تنمية الدافعية والتحصيل", "طلاب التعليم العام", "متابعة التدخلات والخطط المناسبة لرفع الدافعية والتحصيل الدراسي."],
    ["الحادي عشر", "11-15/04/2027م", "استمرار رعاية الحالات الخاصة", "الحالات الخاصة وأسرهم", "استمرار تقديم الخدمات التربوية والنفسية والتنسيق مع الأسرة والمدرسة."],
    ["الثاني عشر", "18-22/04/2027م", "الانضباط المدرسي", "جميع الطلاب وأولياء الأمور", "التوعية بآثار الغياب والتأخر ومتابعة الانضباط وقواعد السلوك والمواظبة."],
    ["الثالث عشر", "25-29/04/2027م", "تنمية الدافعية لرفع التحصيل الدراسي", "جميع الطلاب", "متابعة التحصيل وتعزيز الانضباط وتقديم التدخلات التربوية."],
    ["الرابع عشر", "23-27/05/2027م", "الاستخدام الآمن للإنترنت والألعاب الإلكترونية", "الطلاب وأولياء الأمور", "التوعية بالاستخدام الآمن للتقنية والاستفادة من جوانبها الإيجابية."],
    ["الخامس عشر", "30/05-03/06/2027م", "استمرار التوجيه المهني", "طلاب التعليم العام", "متابعة التعريف بالمسارات التعليمية والفرص المهنية والتخصصات."],
    ["السادس عشر", "06-10/06/2027م", "متابعة تنمية الدافعية والتحصيل", "الطلاب المتوقع تعثرهم", "إعداد الخطط العلاجية ومتابعة إتقان المهارات الأساسية."],
    ["السابع عشر", "13-17/06/2027م", "التهيئة الإرشادية للاختبارات", "جميع الطلاب", "التعريف بلوائح وتعليمات الاختبارات وتهيئة الطلاب نفسياً."],
    ["الثامن عشر", "20-24/06/2027م", "استمرار التهيئة للاختبارات", "جميع الطلاب", "متابعة الاستعداد للاختبارات واستكمال تكريم الطلاب المتميزين سلوكياً."],
    ["التاسع عشر", "27/06-01/07/2027م", "الاختبارات النهائية وإقفال أعمال الفصل", "جميع الطلاب والإدارة المدرسية", "متابعة الطلاب ذوي الحالات الخاصة، واستكمال توثيق البرامج ورفع التقرير الختامي."],
  ],
};

export const SECTIONS = {
  "academic-record": {
    key: "academic_record",
    title: "السجل الأكاديمي",
    icon: "BookOpen",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "category", label: "تصنيف الطالب", type: "select", options: ["متفوق", "ضعيف"], required: true },
      { name: "semester", label: "الفصل الدراسي", type: "select", options: ["الأول", "الثاني", "الثالث"], required: true },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "honors", label: "إتمام تكريم المتفوقين", type: "checks", options: ["تم التكريم وسط الفصل", "تم التكريم نهاية الفصل"] },
      { name: "weakness_reason", label: "سبب الضعف", type: "textarea", academicCategory: "ضعيف" },
      { name: "parent_contacted", label: "تم التواصل مع ولي الأمر", type: "select", options: ["نعم", "لا"], academicCategory: "ضعيف" },
      { name: "support_participated", label: "شارك في برنامج الدعم", type: "select", options: ["نعم", "لا"], academicCategory: "ضعيف" },
      { name: "followups", label: "المتابعة والإجراءات", type: "case_followups", notesLabel: "الإجراءات", showDay: false, options: ["قيد المتابعة", "تحسن", "يحتاج إلى متابعة إضافية"] },
    ],
    columns: ["student", "grade", "category", "semester", "honors", "weakness_reason", "parent_contacted", "support_participated", "followups"],
  },
  "gifted-students": {
    key: "gifted_student",
    title: "سجلات الموهوبين",
    icon: "Star",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "areas", label: "مجالات التميز", type: "checks", customOther: true, options: ["العلوم والرياضيات", "اللغة والأدب", "الفنون", "الرياضة", "القيادة", "التقنية والبرمجة", "الحفظ والتلاوة", "أخرى"] },
      { name: "talent_details", label: "وصف الموهبة", type: "checks", options: ["تفوق أكاديمي", "تفكير إبداعي وابتكاري", "قدرات قيادية", "موهبة علمية وبحثية", "موهبة لغوية وأدبية", "موهبة فنية", "موهبة رياضية", "موهبة تقنية", "موهبة أخرى"] },
      { name: "support_plan", label: "خطة الرعاية والدعم", type: "checks", customOther: true, options: ["إثراء المحتوى الدراسي", "مشروع أو بحث إثرائي", "إشراكه في المسابقات", "تدريب وتنمية المهارات", "توفير مصادر تعلم إضافية", "إرشاد فردي ومتابعة", "التواصل مع الأسرة", "تنمية الموهبة بالتعاون مع جهة مختصة", "أخرى"] },
      { name: "achievements", label: "الإنجازات", type: "checks", customOther: true, options: ["المشاركة في مسابقة", "تحقيق مركز متقدم", "الحصول على جائزة أو تكريم", "إنجاز مشروع أو بحث", "إنتاج عمل إبداعي", "تمثيل المدرسة", "إنجاز أكاديمي متميز", "أخرى"] },
      { name: "notes", label: "ملاحظات", type: "textarea" },
    ],
    columns: ["student", "grade", "areas", "talent_details", "support_plan", "achievements"],
  },
  "radio-broadcast": {
    key: "radio_broadcast",
    title: "الإذاعة الإرشادية",
    icon: "Radio",
    fields: [
      { name: "date", label: "اليوم والتاريخ", type: "date", required: true },
      { name: "program", label: "البرنامج الإذاعي", type: "text", required: true },
      { name: "area", label: "المجال الإرشادي", type: "checks", customOther: true, options: ["تربوي", "صحي", "اجتماعي", "نفسي", "وقائي", "أخلاقي", "أخرى"] },
      { name: "evidence", label: "الشواهد", type: "checks", options: ["كلمة", "عرض مرئي", "مشهد تمثيلي", "توزيع مطويات", "شهادات شكر", "استضافة"] },
      { name: "evidence_other", label: "شواهد أخرى", type: "text" },
      { name: "notes", label: "ملاحظات", type: "textarea" },
    ],
    columns: ["date", "program", "area", "evidence"],
  },
  "guidance-lessons": {
    key: "guidance_lesson",
    title: "الحصص الإرشادية",
    icon: "BookOpen",
    fields: [
      { name: "date", label: "اليوم والتاريخ", type: "date", required: true },
      { name: "session", label: "الحصة", type: "select", options: ["1", "2", "3", "4", "5", "6", "7", "8"] },
      { name: "grade", label: "الفصل", type: "select", options: GRADES },
      { name: "topic", label: "الموضوع", type: "text", required: true },
      { name: "area", label: "المجال الإرشادي", type: "checks", customOther: true, options: ["تربوي", "صحي", "اجتماعي", "نفسي", "وقائي", "أخلاقي", "أخرى"] },
      { name: "outcomes", label: "النتائج", type: "checks", options: ["استجابة الجميع", "تطبيق", "تكرار للموضوع", "التفعيل كبرنامج للفصل"] },
      { name: "outcomes_other", label: "نتائج أخرى", type: "text" },
    ],
    columns: ["date", "session", "grade", "topic", "area", "outcomes"],
  },
  "special-cases": {
    key: "special_case",
    title: "الحالات الخاصة",
    icon: "AlertTriangle",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "health", label: "الحالات الصحية (يمكن اختيار أكثر من حالة)", type: "checks", preserveChoices: true, exclusiveOption: "لا توجد حالة صحية", options: ["ربو", "سكري", "حساسية", "صرع", "أمراض القلب", "ضعف سمع", "ضعف بصر", "حالة صحية أخرى", "لا توجد حالة صحية"] },
      { name: "handling", label: "طرق التعامل (يمكن اختيار أكثر من طريقة)", type: "checks", preserveChoices: true, options: ["متابعة الحالة الصحية", "مراعاة الحالة أثناء اليوم الدراسي", "التواصل مع ولي الأمر", "توفير بيئة آمنة", "إبلاغ المعلمين المعنيين", "توفير الدواء وفق تعليمات ولي الأمر", "خطة للتعامل مع الطوارئ", "إحالة للممرضة أو الجهة الصحية", "طريقة أخرى"] },
      { name: "phone", label: "هاتف ولي الأمر", type: "text" },
      { name: "notes", label: "ملاحظات", type: "textarea" },
    ],
    columns: ["student", "grade", "health", "handling", "phone", "notes"],
  },
  "individual-sessions": {
    key: "individual_session",
    title: "الإرشاد الفردي",
    icon: "User",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "location", label: "المكان", type: "select", options: ["مكتب الإرشاد", "الفصل الدراسي", "مصادر التعلم", "عن بُعد", "مكان آخر"] },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "goals", label: "أهداف الجلسة", type: "checks", options: ["التعرف على المشكلة", "تقديم الدعم النفسي", "تعديل السلوك", "رفع الدافعية والتحصيل", "تنمية المهارات الاجتماعية", "تعزيز الثقة بالنفس", "متابعة حالة خاصة", "هدف آخر"] },
      { name: "recommendations", label: "التوصيات", type: "checks", options: ["متابعة الطالب", "التواصل مع ولي الأمر", "التنسيق مع المعلمين", "إحالة للجهة المختصة", "خطة إرشادية فردية", "تعزيز السلوك الإيجابي", "جلسة متابعة", "توصية أخرى"] },
    ],
    columns: ["student", "grade", "location", "date", "goals", "recommendations"],
  },
  "group-sessions": {
    key: "group_session",
    title: "الإرشاد الجمعي",
    icon: "Users",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "location", label: "المكان", type: "text" },
      { name: "count", label: "العدد", type: "number" },
      { name: "guest", label: "ضيف الجلسة", type: "text" },
      { name: "target", label: "الفئة المستهدفة", type: "text" },
      { name: "students", label: "الطلاب المشاركون", type: "checks" },
      { name: "goals", label: "أهداف الجلسة", type: "checks", options: ["تعزيز التعاون والعمل الجماعي", "تنمية المهارات الاجتماعية", "تعزيز السلوك الإيجابي", "الوقاية من التنمر", "رفع الدافعية والتحصيل", "التوعية النفسية والاجتماعية", "حل المشكلات", "هدف آخر"] },
      { name: "recommendations", label: "التوصيات", type: "checks", options: ["متابعة الطلاب", "التواصل مع أولياء الأمور", "تنفيذ جلسة إرشادية لاحقة", "التنسيق مع المعلمين", "إحالة الطلاب المحتاجين للدعم", "تعزيز السلوك الإيجابي", "توصية أخرى"] },
    ],
    columns: ["date", "grade", "location", "count", "target", "students", "goals", "recommendations"],
  },
  "info-form": {
    key: "info_form",
    title: "دراسة حالة",
    icon: "FileText",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "age", label: "العمر", type: "number" },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "problem", label: "المشكلة", type: "checks", options: ["ضعف التحصيل الدراسي", "كثرة الغياب", "التأخر الصباحي", "مشكلات سلوكية", "صعوبات التعلم", "ضعف الدافعية", "مشكلات أسرية", "مشكلات نفسية أو اجتماعية", "التنمر", "أخرى"] },
      { name: "problem_start", label: "تاريخ ظهور المشكلة", type: "date" },
      { name: "family", label: "الوضع الأسري", type: "select", options: ["مستقر", "غير مستقر"] },
      { name: "health", label: "الحالة الصحية", type: "select", options: ["جيدة", "يعاني من مشكلات"] },
      { name: "relations", label: "العلاقات", type: "select", options: ["جيدة", "ضعيفة"] },
      { name: "achievement", label: "التحصيل", type: "select", options: ["جيد", "متوسط", "ضعيف"] },
      { name: "negative", label: "السلوكيات السلبية", type: "checks", options: ["كثرة الغياب", "التأخر الصباحي", "عدم الالتزام بالأنظمة", "العدوان", "التنمر", "ضعف المشاركة", "الانسحاب والعزلة", "إهمال الواجبات", "أخرى"] },
      { name: "positive", label: "السلوكيات الإيجابية", type: "checks", options: ["التعاون", "احترام الآخرين", "الالتزام بالأنظمة", "المشاركة الصفية", "المحافظة على الممتلكات", "تحمل المسؤولية", "المواظبة", "المبادرة", "أخرى"] },
      { name: "status", label: "وضع الحالة", type: "select", options: ["مستمرة", "مغلقة"], defaultValue: "مستمرة" },
      { name: "notes", label: "ملاحظات", type: "textarea" },
      { name: "followups", label: "جدول متابعة الحالة", type: "case_followups", showDay: false },
      { name: "supervisor", label: "متابعة المشرف الإرشادي", type: "select", options: ["آدم المحنبي", "خلود خالد"] },
    ],
    columns: ["student", "grade", "problem", "status", "date", "notes", "followups", "supervisor"],
  },
  "parents": {
    key: "parent_contact",
    title: "أولياء الأمور",
    icon: "Users",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "الطالب", type: "text", required: true },
      { name: "parent", label: "ولي الأمر", type: "select", options: ["الأب", "الأم", "ولي الأمر", "أخرى"] },
      { name: "method", label: "الوسيلة", type: "select", options: ["هاتف", "واتساب", "رسالة", "زيارة", "تطبيق مدرستي", "اجتماع"] },
      { name: "phone", label: "رقم ولي الأمر", type: "text" },
      { name: "caller", label: "المتصل", type: "caller" },
      { name: "contact_status", label: "حالة التواصل", type: "select", options: ["بدء التواصل", "تم التواصل", "لم يتم التواصل"] },
      { name: "reason", label: "السبب", type: "checks", options: ["متابعة المستوى الدراسي", "كثرة الغياب", "التأخر الصباحي", "مشكلة سلوكية", "تعزيز السلوك الإيجابي", "متابعة حالة إرشادية", "ملاحظة صحية أو اجتماعية", "أخرى"] },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "recommendations", label: "التوصيات", type: "checks", options: ["متابعة الطالب في المنزل", "التواصل المستمر مع المدرسة", "تنظيم وقت المذاكرة", "الالتزام بالحضور والانصراف", "تعزيز السلوك الإيجابي", "متابعة الخطة العلاجية", "حضور موعد متابعة", "توصية أخرى"] },
      { name: "notes", label: "ملاحظات", type: "textarea" },
    ],
    columns: ["student", "parent", "phone", "caller", "method", "contact_status", "reason", "date", "recommendations"],
  },
  "class-visits": {
    key: "class_visit",
    title: "الزيارات الصفية",
    icon: "School",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES },
      { name: "teacher", label: "المعلم", type: "text" },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "goal", label: "الهدف", type: "checks", customOther: true, options: ["متابعة المستوى التحصيلي", "تعزيز الدافعية للتعلم", "تحسين إدارة الصف", "دعم الطلاب المتعثرين", "تعزيز المشاركة الصفية", "متابعة الانضباط والسلوك", "تقديم دعم إرشادي للطلاب", "التعرف على احتياجات الطلاب", "أخرى"] },
      { name: "notes", label: "الملاحظات", type: "checks", options: ["تفاعل الطلاب جيد", "مشاركة الطلاب فعالة", "يحتاج بعض الطلاب إلى متابعة", "تنوعت استراتيجيات التدريس", "البيئة الصفية مناسبة", "وجود تحديات في الانضباط", "ملاحظات أخرى"] },
      { name: "recommendations", label: "التوصيات", type: "checks", options: ["متابعة الطلاب المتعثرين", "تعزيز مشاركة الطلاب", "تنويع استراتيجيات التدريس", "تعزيز السلوك الإيجابي", "التواصل مع ولي الأمر", "تنفيذ زيارة متابعة", "تقديم دعم إرشادي", "توصية أخرى"] },
    ],
    columns: ["grade", "teacher", "date", "goal", "notes", "recommendations"],
  },
  "programs": {
    key: "program",
    title: "البرامج الإرشادية",
    icon: "Target",
    fields: [
      { name: "program", label: "البرنامج", type: "select", options: ["التهيئة الإرشادية", "برنامج رفق", "التعزيز الإيجابي", "الأسبوع المهني", "رفع دافعية التعلم", "التحذير من الألعاب", "الانضباط المدرسي", "أخرى"] },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "beneficiary_scope", label: "المستفيدون", type: "beneficiary_target", required: true },
      { name: "executor", label: "المنفذ", type: "text" },
      { name: "results", label: "النتائج", type: "checks", options: ["تحقق الهدف", "تحسن السلوك الإيجابي", "ارتفاع مستوى الوعي", "زيادة مشاركة الطلاب", "استفادة الفئة المستهدفة", "الحاجة إلى متابعة", "نتيجة أخرى"] },
      { name: "evidence_files", label: "الشواهد والمرفقات", type: "attachments" },
      { name: "notes", label: "ملاحظات", type: "textarea" },
    ],
    columns: ["program", "date", "beneficiary_scope", "executor", "results"],
  },
  "absence": {
    key: "absence",
    title: "متابعة الغياب والتأخر المتكرر",
    icon: "CalendarX",
    fields: [
      { name: "attendance_type", label: "نوع المتابعة", type: "select", options: ["غياب", "تأخر"], required: true, defaultValue: "غياب" },
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "الطالب", type: "text", required: true },
      { name: "days", label: "عدد أيام الغياب أو التأخر", type: "number" },
      { name: "from_date", label: "من تاريخ", type: "date" },
      { name: "to_date", label: "إلى تاريخ", type: "date" },
      { name: "reason", label: "السبب", type: "checks", options: ["ظروف صحية", "ظروف أسرية", "ضعف الدافعية", "صعوبة المواصلات", "عدم الرغبة في الحضور", "السهر أو عدم تنظيم الوقت", "غياب دون عذر", "أسباب أخرى"] },
      { name: "contacted", label: "التواصل", type: "select", options: ["نعم", "لا"] },
      { name: "action", label: "الإجراء", type: "checks", options: ["التواصل مع ولي الأمر", "تقديم التوجيه والإرشاد", "أخذ تعهد بالمواظبة", "إحالة لإدارة المدرسة", "إعداد خطة متابعة", "متابعة الحضور يومياً", "زيارة منزلية", "إجراء آخر"] },
      { name: "notes", label: "ملاحظات", type: "textarea" },
    ],
    columns: ["student", "grade", "days", "from_date", "to_date", "reason", "contacted", "action"],
  },
  "behavior-contract": {
    key: "behavior_contract",
    title: "التعاقد السلوكي",
    icon: "FileSignature",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES, required: true },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "start", label: "يبدأ يوم", type: "date" },
      { name: "end", label: "ينتهي يوم", type: "date" },
      { name: "items", label: "البنود المتفق عليها", type: "checks", customOther: true, options: ["الالتزام بالحضور والانصراف", "احترام المعلمين والزملاء", "اتباع أنظمة وتعليمات المدرسة", "المحافظة على الممتلكات المدرسية", "إنجاز الواجبات والمهام", "الالتزام بالهدوء داخل الفصل", "الاستئذان قبل مغادرة الفصل", "المحافظة على نظافة الفصل", "التعاون والمشاركة الإيجابية", "أخرى"] },
      { name: "reward", label: "المكافأة عند الالتزام", type: "checks", customOther: true, options: ["عبارات التعزيز والثناء", "شهادة شكر وتقدير", "إشعار ولي الأمر بالتحسن", "منح امتياز أو مسؤولية", "تكريم أمام الزملاء", "إشراكه في نشاط محبب", "أخرى"] },
      { name: "noncompliance", label: "في حالة عدم الالتزام", type: "checks", customOther: true, options: ["جلسة إرشادية ومراجعة أسباب عدم الالتزام", "إشعار ولي الأمر", "متابعة يومية مع المرشد الطلابي", "إحالة لإدارة المدرسة", "تعديل خطة الدعم السلوكي", "تحديد موعد متابعة جديد", "أخرى"] },
    ],
    columns: ["student", "grade", "start", "end", "items", "reward", "noncompliance"],
  },
  "daily-incidents": {
    key: "daily_incident",
    title: "المواقف اليومية",
    icon: "AlertCircle",
    fields: [
      { name: "grade", label: "الصف", type: "select", options: GRADES },
      { name: "student", label: "اسم الطالب", type: "text", required: true },
      { name: "day", label: "اليوم", type: "select", options: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس"] },
      { name: "date", label: "التاريخ", type: "date" },
      { name: "subject", label: "المادة", type: "text" },
      { name: "type", label: "نوع الموقف", type: "select", options: ["سلوكي", "تحصيلي", "انضباطي", "اجتماعي", "أخرى"] },
      { name: "description", label: "وصف الموقف", type: "checks", required: true, options: ["مشاجرة أو اعتداء", "تنمر", "عدم التزام بالتعليمات", "تأخر أو غياب", "إتلاف ممتلكات", "إزعاج داخل الفصل", "رفض أداء الواجب", "مخالفة سلوكية أخرى"] },
      { name: "actions", label: "الإجراءات التربوية المتخذة", type: "checks", options: ["توجيه وإرشاد فردي", "تعاقد سلوكي", "التواصل مع ولي الأمر", "إحالة لإدارة المدرسة", "متابعة سلوكية", "إجراء تربوي مناسب", "إجراء آخر"] },
      { name: "parent_contact", label: "التواصل مع ولي الأمر", type: "select", options: ["لم يتم", "هاتف", "رسالة", "زيارة", "تطبيق المدرسة"] },
      { name: "status", label: "الحالة", type: "select", options: ["مفتوح", "قيد المتابعة", "مغلق"] },
      { name: "notes", label: "ملاحظات إضافية", type: "textarea" },
    ],
    columns: ["student", "grade", "day", "date", "subject", "type", "description", "status"],
  },
  "monthly-report": {
    key: "monthly_report",
    title: "التقرير الشهري",
    icon: "BarChart3",
    fields: [
      { name: "month", label: "الشهر", type: "select", options: ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"] },
      { name: "school", label: "المدرسة", type: "text" },
      { name: "department", label: "القسم", type: "text" },
      { name: "programs_summary", label: "ملخص البرامج المنفذة", type: "textarea" },
      { name: "cases_summary", label: "ملخص الحالات المتابعة", type: "textarea" },
      { name: "absences", label: "الغياب المتكرر (عدد)", type: "number" },
      { name: "tardies", label: "التأخر المتكرر (عدد)", type: "number" },
      { name: "bullying", label: "التنمر (عدد)", type: "number" },
      { name: "improved", label: "حالات تحسنت", type: "number" },
      { name: "ongoing", label: "حالات مستمرة", type: "number" },
      { name: "suggestions", label: "ملاحظات واقتراحات", type: "textarea" },
    ],
    columns: ["month", "school", "improved", "ongoing", "suggestions"],
  },
};

export const SECTION_ORDER = [
  "general",
  "academic-record",
  "semester-plan",
  "special-cases",
  "individual-sessions",
  "group-sessions",
  "info-form",
  "parents",
  "class-visits",
  "programs",
  "absence",
  "behavior-contract",
  "monthly-report",
  "guidance-committee",
  "student-council",
  "daily-incidents",
  "backup",
];

export function programBeneficiaryText(data = {}) {
  if (data.beneficiary_scope === "all_school") return "جميع طلاب المدرسة";
  if (data.beneficiary_scope === "selected_grades") return `صفوف محددة: ${(data.beneficiary_grades || []).join("، ")}`;
  return data.beneficiaries !== undefined && data.beneficiaries !== "" ? `عدد محفوظ سابقاً: ${data.beneficiaries}` : "—";
}

export const SECTION_LABELS = {
  "general": { title: "معلومات عامة", icon: "Home" },
  "semester-plan": { title: "الخطة الفصلية", icon: "Calendar" },
  "guidance-committee": { title: "لجنة التوجيه والإرشاد", icon: "ClipboardCheck" },
  "student-council": { title: "المجلس الطلابي", icon: "Landmark" },
  "backup": { title: "النسخ الاحتياطي", icon: "Database" },
};
